export default import.meta.ROLLUP_FILE_URL_ZTw8NDDFfUsQJ61W2F0NNQ